<div class=" mt-4">
  <section>
      <div class="row">
          <div class="col-md-10">
              <div class="float-right">
                <button class="btn dash-btns " [routerLink]="['/pos/ordertype/manage']">Manage Order Type</button>
              </div>
          </div>
      </div>

  </section>
  <section class="mt-3">
      <div class="">
          <div class="row">
              <div class="col-md-8 offset-md-2">
                  <div class="card-1">
                      <div class="row">
                          <div class="col-md-12">
                              <!-- <div class="text-center mb-5">
                                  <img src="assets/img/new/view-trans.svg" />
                              </div> -->
                              <div class="text-center" *ngIf="isNewOrderType">
                                  <a class="view-h gary-t">New Order Type</a>
                              </div>
                              <div class="text-center" *ngIf="isUpdateOrderType">
                                <a class="view-h gary-t"> Order Type</a>
                            </div>
                               
                            <form #fnebusiness="ngForm">
                              <div class="mt-3">
                                <!-- New Order starts -->
                                <div *ngIf="isNewOrderType">
                                  <form #form="ngForm" class="addpaynow">
                                    <div class="form-group">
                  
                                      <div class="row pt-2">
                                        <div class="col-md-5 col-lg-4">
                                          <label for="sel1">Order Type
                                            <span class="text-danger">*</span></label>
                                        </div>
                  
                                        <div class="col-md-6 col-lg-7">
                                          <div class="form-group">
                                            <input type="text" class="formcontrol-user form-control" placeholder="Order Type" id="OrderType" name="OrderType"
                                              [formControl]="OrderType" required>
                                          </div>
                                          <span class="text-danger"
                                            *ngIf="OrderType.invalid && (OrderType.dirty || OrderType.touched)">{{ordertypeError()}}</span>
                                        </div>
                                      </div>
                  
                                      <div class="row pt-2">
                  
                                        <div class="col-md-5 col-lg-4">
                                          <label for="sel1">DefaultOrderType</label>
                                          <!-- <label for="sel1">DefaultOrderType <span
                                                    class="text-danger"></span></label> -->
                                        </div>
                  
                                        <div class="col-md-6 col-lg-7">
                                          <div class="form-group">
                                            <input type="checkbox" [(ngModel)]="DefaultOrderType" id="DefaultOrderType"
                                              name="DefaultOrderType" (click)="DefaultOrderType1()" />
                                          </div>
                                        </div>
                                      </div>
                  
                                      <div class="pt-3">
                                        <button class="dash-btns btn" type="button" id="btnSaveOrderType" 
                                          [disabled]="OrderType.invalid" (click)="newOrderType()">Submit</button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                                <!-- order Update starts -->
                                <div   *ngIf="isUpdateOrderType">
                                  <form #form="ngForm" class="addpaynow">
                                    <div class="form-group">
                  
                  
                                      <div class="row pt-2">
                                        <div class="col-md-5 col-lg-4">
                                          <label for="sel1">Order Type
                                            <span class="text-danger">*</span></label>
                                        </div>
                  
                                        <div class="col-md-6 col-lg-7">
                                          <div class="form-group">
                                            <input type="text" class="formcontrol-user form-control" placeholder="Order Type" [(ngModel)]="rows.orderType" id="OrderType"
                                              name="OrderType" [formControl]="OrderType" (keydown)="onKey()" required>
                                          </div>
                                          <span class="text-danger"
                                            *ngIf="OrderType.invalid && (OrderType.dirty || OrderType.touched)">{{ordertypeError()}}</span>
                                        </div>
                                      </div>
                  
                                      <div class="row pt-2">
                  
                                        <div class="col-md-5 col-lg-4">
                                          <label for="sel1">DefaultOrderType</label>
                  
                                        </div>
                  
                                        <div class="col-md-6 col-lg-7">
                                          <div class="">
                                            <input type="checkbox" [(ngModel)]="rows.defaultOrderType" id="DefaultOrderType"
                                              name="DefaultOrderType" (click)="DefaultOrderType1()" (click)="onKey()" />
                                          </div>
                                        </div>
                                      </div>
                  
                                      <!-- <div class="row pt-2">
                                    <div class="form-group row">
                                      <div class="col-xl-10 col-md-9 col-8">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input"  type="checkbox" [(ngModel)]="rows.defaultOrderType" id="DefaultOrderType" name="DefaultOrderType" (click)="DefaultOrderType1()"/>
                                            <label class="custom-control-label" for="DefaultOrderType">DefaultOrderType</label>
                                        </div>
                                    </div>
                                  </div>
                                  </div> -->
                  
                                      <input type="hidden" [(ngModel)]="rows.id" id="id" name="id" [formControl]="id">
                  
                                      <div class="pt-3">
                                        <button class=" dash-btns btn mr-3"  [routerLink]="['/pos/ordertype/manage',{}]">Cancel</button>
                  
                                        <button class="dash-btns btn" type="button" id="btnUpdateOrderType"  [disabled]="OrderType.invalid ||!isReadytoUpdateordertype"
                                          (click)="updateOrderType()">Update</button>
                                      </div>
                  
                                    </div>
                                  </form>
                  
                                </div>                
                              </div>
                            </form>
                          </div>
                      </div>
                  </div>
              </div>

          </div>
      </div>
  </section>
</div>






 